import type { SyncOrAsync } from '@quromedical/utils';

import type { FileType } from './renderer';

export { FileType } from './renderer';

export interface MediaPreviewProps {
  /**
   * Any for the media element that will uniquely identify the resulting file
   */
  id: string;
  type?: FileType;
  getUrl: SyncOrAsync<() => string>;
  title: string;
}
